import _                                   from 'underscore';
import moment                              from 'moment';
import React, { FC, ReactNode, useState }  from 'react';
import { Cell, Grid }                      from "styled-css-grid";
import { StyledContainer }                 from '../../../../containers';
import { Position, SemanticUIColor, Size } from '../../../../../types';
import { percentage }                      from '../../../../../util';
import { VisualizationSummaryTile } from '../../common/visualization/display/VisualizationSummaryTile';
import { RuledTimeLineGrid }        from '../../mapping/grid/RuledTimeLineGrid';
import { Segment, SegmentProps }    from 'semantic-ui-react';
import { GridColumnInfoType }              from './ProjectListItemCalendar';
import { Moment }                          from 'moment';
import { FinePrintMessage }                from '../../../../components/util/messaging/FinePrintMessage';

export interface ProjectListItemCalendarItemLayoutProps {
	items: any[],
	itemRender: ( item: any ) => ReactNode,
	itemDisplayOffsetPX: number,
	itemMinWidth: number,
	getItemDate: ( item: any ) => Moment,
	gridColumnCount: number,
	gridColumns: GridColumnInfoType[],
	containerColor: SemanticUIColor.TEAL | SemanticUIColor.PURPLE,
	containerProps: Omit<SegmentProps, 'color'>,
	emptyComponent: ( gridColumnInfo: GridColumnInfoType[] ) => ReactNode
}

const defaultProps: ProjectListItemCalendarItemLayoutProps = {
	items:               [],
	itemRender:          () => null,
	itemDisplayOffsetPX: -10,
	itemMinWidth:        55,
	getItemDate:         () => moment(),
	gridColumnCount:     0,
	gridColumns:         null,
	containerColor:      SemanticUIColor.TEAL,
	containerProps:      { style: { padding: '0 40px 0 0' } },
	emptyComponent:      null,
}

const ProjectListItemCalendarItemLayout: FC<ProjectListItemCalendarItemLayoutProps> = ( props ) => {

	let { items, getItemDate, itemRender, itemDisplayOffsetPX, itemMinWidth } = props,
	    { gridColumnCount, gridColumns, containerColor, containerProps }      = props;

	let hasGridColumnInfo = !_.isEmpty( gridColumns ),
	    hasItemSet        = !_.isEmpty( items );

	/* No grid Column Info*/
	if( !hasGridColumnInfo ) return null;

	let [ startTime ] = _.first( gridColumns ),
	    [ , endTime ] = _.last( gridColumns );

	/* Calendar Display*/
	return (

		<Segment basic color={ containerColor } { ...containerProps }>

			{ !hasItemSet && (

				<Grid columns={ 1 } columnGap={ '0px' }>

					<Cell center className={ 'position--relative' }>

						{/* Items in Month */ }
						<StyledContainer zIndex={ 200 } position={ Position.RELATIVE } padding={ [ Size.MD, null ] }>

							{ props.emptyComponent ? props.emptyComponent( gridColumns ) : null }

						</StyledContainer>

						{/* Grid Lines for Month */ }
						<StyledContainer zIndex={ 100 } position={ Position.ABSOLUTE } fill={ 'area' }>
							<RuledTimeLineGrid startDate={ startTime }
							                   endDate={ endTime }
							                   ruleOpacity={ 30 }
							                   showlabels={ true }
							                   gridProps={ { style: { height: '100%' } } }
							/>
						</StyledContainer>

					</Cell>

				</Grid>

			) }

			{ hasItemSet && (
				<Grid columns={ gridColumnCount } columnGap={ '0px' }>

					{ gridColumns.map( ( gridColumn, gridColumnIndex ) => {

						let [ startDate, endDate, dayCount ] = gridColumn,
						    columnItems                      = _.filter( items, item => getItemDate( item ).isBetween( startDate, endDate, null, '[]' ) );

						return (
							<Cell key={ gridColumnIndex } width={ dayCount } className={ 'position--relative' } style={ { zIndex: gridColumns.length - gridColumnIndex } }>

								{/* Items in Month */ }
								<StyledContainer zIndex={ 200 } position={ Position.RELATIVE } padding={ [ Size.MD, null ] }>

									<Grid columns={ 1 } columnGap={ '0px' } rows={ `20px` }>

										{ columnItems.map( ( columnItem, columnItemIndex ) => {

											let itemDate     = getItemDate( columnItem ),
											    itemDayIndex = parseInt( itemDate.format( 'DD' ) ) ?? 1;

											return (

												<Cell key={ columnItemIndex } className={ 'position--relative' }>

													<StyledContainer position={ Position.ABSOLUTE } left={ `calc( ${ percentage( itemDayIndex, dayCount, 'floor' ) }% + ${ itemDisplayOffsetPX }px )` } style={ { minWidth: itemMinWidth } }>

														{ itemRender( columnItem ) }

													</StyledContainer>

												</Cell>

											);

										} ) }

									</Grid>

								</StyledContainer>

								{/* Grid Lines for Month */ }
								<StyledContainer zIndex={ 100 } position={ Position.ABSOLUTE } fill={ 'area' }>
									<RuledTimeLineGrid startDate={ startDate }
									                   endDate={ endDate }
									                   ruleOpacity={ 30 }
									                   showlabels={ true }
									                   gridProps={ { style: { height: '100%' } } }
									/>
								</StyledContainer>

							</Cell>
						);
					} ) }

				</Grid>
			) }

		</Segment>
	);
};

ProjectListItemCalendarItemLayout.defaultProps = defaultProps;

export { ProjectListItemCalendarItemLayout }
